import { render, staticRenderFns } from "./BasicExcelTemplate.vue?vue&type=template&id=1976b0b8&scoped=true"
import script from "./BasicExcelTemplate.vue?vue&type=script&lang=js"
export * from "./BasicExcelTemplate.vue?vue&type=script&lang=js"
import style0 from "./BasicExcelTemplate.vue?vue&type=style&index=0&id=1976b0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976b0b8",
  null
  
)

export default component.exports